var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Row',[_c('h2',[_vm._v("工作台")])]),_c('br'),_c('Row',[_c('Button',{attrs:{"size":"large","type":"primary","icon":"ios-trash"},on:{"click":_vm.cleanCache}},[_vm._v("清除缓存")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }